export default () => ({
  isLoading: false,
  isError: false,
  trashbin: [],
});
